import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { AuthUrl, httpStatus, errorTypes } from "../../constants";
import * as api from '../../tools/apiMiddleware';
import { isStringNullOrWhiteSpace } from '../../tools/validator';

export const Verify2FASteps = {
    Introducing: 1,
    SendingCode: 2,
    SendCodeToEmail: 3,
    SendCodeToMobile: 4,
    VerifyMobile: 5,
    VerifyCode: 6,
    Verified: 7,
    Disabled: 8,
    EmailVerification: 9,
    Logout: 10
};

const initialState = {
    data: { resendTimeout: 30, canSkip: false, email: '', mobile: '' },
    step: Verify2FASteps.Introducing,
    previousStep: Verify2FASteps.Introducing,
    canResend: false,
    resendCounter: -1,
    iconName: 'key',
    skip2FASteps: false,
    isLoading: false,
    hasErrorOccured: false,
    gatewayUri: undefined,
    maxResendAttempts: 5
};

export const actionCreators = {
    get2FADetail: () => async (dispatch, getState) => {

        let url = AuthUrl + apiRoutes.Get2FADetails;
        await api.getRequest(dispatch, url, actionTypes.VERIFY_2FA, actionTypes.GET_2FA_SUCCESS, actionTypes.VERIFY_2FA_FAIL);
    },
    sendCode: (step) => async (dispatch, getState) => {

        await dispatch({ type: actionTypes.SEND_2FA, step });

        if (step === Verify2FASteps.SendCodeToEmail) {
            let url = AuthUrl + apiRoutes.SendCodeToEmail;
            await api.postRequest(dispatch, url, null, actionTypes.VERIFY_2FA, actionTypes.SEND_2FA_SUCCESS, actionTypes.VERIFY_2FA_FAIL, true);
        }
        else if (step === Verify2FASteps.SendCodeToMobile) {
            let data = getState().verification2FA.data;
            if (isStringNullOrWhiteSpace(data.mobile)) {

                await dispatch({ type: actionTypes.VERIFY_MOBILE, step: Verify2FASteps.VerifyMobile });
            }
            else {
                let url = AuthUrl + apiRoutes.SendCodeToMobile;
                await api.postRequest(dispatch, url, null, actionTypes.VERIFY_2FA, actionTypes.SEND_2FA_SUCCESS, actionTypes.VERIFY_2FA_FAIL, true);
            }
        }
    },
    enableResend: () => async (dispatch) => {
        await dispatch({ type: actionTypes.ENABLE_RESEND_2FA_SUCCESS });
    },
    disableResend: () => async (dispatch) => {
        await dispatch({ type: actionTypes.DISABLE_RESEND_2FA_SUCCESS });
    },
    verifyIntroducing: () => async (dispatch, getState) => {
        await dispatch({ type: actionTypes.VERIFY_2FA_INTRODUCING_SUCCESS, step: Verify2FASteps.SendingCode, data: getState().verification2FA.data });
    },
    verify: (code) => async (dispatch, getState) => {

        if (isStringNullOrWhiteSpace(code)) {
            await dispatch({ type: actionTypes.VERIFY_2FA_FAIL, data: { message: 'Entered code is incorrect or has expired.' } });
        }
        else {
            let url = AuthUrl + apiRoutes.Verify2FA;
            await api.postRequest(dispatch, url, { code }, actionTypes.VERIFY_2FA, actionTypes.VERIFY_2FA_SUCCESS, actionTypes.VERIFY_2FA_FAIL, true);
        }

    },
    skip2FA: () => async (dispatch, getState) => {

        await dispatch({ type: actionTypes.SKIP_2FA_SUCCESS });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.VERIFY_2FA:
            return {
                ...state,
                data: state.data,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.GET_2FA_SUCCESS:
            if (!action.data.email) {
                return {
                    ...state,
                    data: action.data,
                    isLoading: true,
                    hasErrorOccured: false,
                    step: Verify2FASteps.EmailVerification
                };
            }
            return {
                ...state,
                data: action.data,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.SEND_2FA:
            return {
                ...state,
                step: action.step
            };
        case actionTypes.SEND_2FA_SUCCESS:
            let newIconName = 'device-mobile';
            let canResend = state.canResend;
            let maxResendAttempts = 5;
            let hasErrorOccured = false;
            let resendAttempts = state.resendCounter + 1;

            if (state.step === Verify2FASteps.SendCodeToEmail) {
                newIconName = 'mail';
            }

            if (action.data && action.data.status === 1) {
                canResend = false;
            }

            if (action.data.maxResendAttempts) {
                maxResendAttempts = action.data.maxResendAttempts;
            }

            return {
                ...state,
                previousStep: state.step,
                step: Verify2FASteps.VerifyCode,
                iconName: newIconName,
                canResend: canResend,
                resendCounter: resendAttempts,
                isLoading: false,
                hasErrorOccured: resendAttempts >= maxResendAttempts,
                maxResendAttempts: maxResendAttempts,
                errorData: { message: 'The resend limit has been reached. Please contact support.' }
            };
        case actionTypes.ENABLE_RESEND_2FA_SUCCESS:
            return {
                ...state,
                canResend: true

            };
        case actionTypes.DISABLE_RESEND_2FA_SUCCESS:
            return {
                ...state,
                canResend: false
            };
        case actionTypes.SKIP_2FA_SUCCESS:
            return {
                ...state,
                skip2FASteps: true,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.VERIFY_MOBILE:
            return {
                ...state,
                step: action.step,
                iconName: 'device-mobile'
            };
        case actionTypes.VERIFY_MOBILE_SUCCESS:
            return {
                ...state,
                step: Verify2FASteps.VerifyCode
            };
        case actionTypes.VERIFY_2FA_INTRODUCING_SUCCESS:
            return {
                ...state,
                data: action.data,
                step: action.step,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.VERIFY_2FA_SUCCESS:

            if (action.data.redirectUri) {
                return {
                    ...state,
                    step: action.httpStatus === httpStatus.Forbidden ? state.step : Verify2FASteps.Verified,
                    gatewayUri: action.httpStatus === httpStatus.Forbidden ? undefined : action.data.redirectUri,
                    isLoading: false,
                    hasErrorOccured: action.httpStatus === httpStatus.Forbidden,
                    errorData: { message: 'Entered code is incorrect or has expired.' }
                };
            }
            else if (action.data.disabled === true && state.step === Verify2FASteps.VerifyCode) {
                return {
                    ...state,
                    previousStep: state.step,
                    step: Verify2FASteps.Disabled,
                    isLoading: false,
                    data: state.data,
                    hasErrorOccured: false,
                    errorData: { message: ' ' }
                };
            }
            else {
                let actionData = action.data;

                actionData.message = "Entered code is incorrect or has expired.";

                return {
                    ...state,
                    isLoading: false,
                    data: state.data,
                    hasErrorOccured: true,
                    errorData: actionData
                };
            }
        case actionTypes.VERIFY_2FA_FAIL:

            if (action.data.errorType === errorTypes.Unauthorized) {
                return {
                    ...state,
                    isLoading: false,
                    previousStep: state.step,
                    step: Verify2FASteps.Logout,
                    data: state.data,
                    hasErrorOccured: false,
                    errorData: action.data
                };
            }
            
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/Auth/Verification2FAStore.js